const ACTION_SCOPE = '[Navigation]';

export class NavigateBack {
  static readonly type = `${ACTION_SCOPE} Navigate Back`;

  constructor(
    readonly fromCasesPage?: boolean,
    readonly initialUrl?: string,
  ) {}
}

export class PopHistory {
  static readonly type = `${ACTION_SCOPE} Pop History`;
}

export class PushHistory {
  static readonly type = `${ACTION_SCOPE} Push History`;

  constructor(readonly newUrl: string) {}
}

export class ClearHistory {
  static readonly type = `${ACTION_SCOPE} Clear History`;
}
